module.exports = __webpack_public_path__ + "f211f59411f72cd679fe15163a488826.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-Axis-webfont.woff
// module id = 404
// module chunks = 0